import { overrideForZHToCNLanguage, useSessionLanguage } from '@context/SessionSettingsContext'

type SupportedLocale = 'en' | 'pt' | 'ko' | 'ms' | 'vi'
type LocaleToLanguageMap = Record<SupportedLocale, string>

const localeToPlatformLanguageIdMap: LocaleToLanguageMap = {
  en: 'www',
  pt: 'br',
  ko: 'kr',
  ms: 'my',
  vi: 'vn',
}

export const useTradingViewTradeUrl = () => {
  const locale = useSessionLanguage()
  const languageId = overrideForZHToCNLanguage(locale) as SupportedLocale

  const normalizedLanguageId = localeToPlatformLanguageIdMap[languageId] ?? languageId

  return `https://${normalizedLanguageId}.tradingview.com/chart/?trade-now=TICKMILL`
}
